/**
 * The app navbar's expanded and collapsed widths, as Tailwind class literals.
 *
 * Shared by the navbar itself and by anything that has to line up with it, so both pick their class from
 * `isCollapsed` and stay in step through the same transition.
 *
 * Written out as literals rather than interpolated from a pixel constant, because Tailwind's scanner
 * reads source text statically: a class assembled at runtime — `` w-[${width}] `` — is never emitted,
 * so the width silently does not apply. Mirrors the approach in `header-sizing.ts`.
 */
export const NAVBAR_WIDTH_CLASSES = {
  expanded: "w-[254px]",
  collapsed: "w-[0px]",
} as const;
